<template>
  <div class="sidepanel-learn-item">
<!--    <div class="flex items-start w-full mb-2">-->

      <div class="flex flex-row justify-start">
        <p class="flex flex-1 items-start mb-2">
          <feather-icon class="cursor-pointer" icon="FilmIcon"
                        svgClasses="text-primary stroke-current h-5 w-5 mr-4 mt-1 p-0"/>
          <span class="text-lg text-primary">{{ topic.nameLocal }}</span>
        </p>
      </div>
      <div class="flex flex-row">
        <div class="flex flex-col justify-start w-2/3">
          <vs-button
            :color="percentCounter > 99 ? 'success' : 'primary'" class="w-3/4" icon="icon-play"
            icon-pack="feather"
            size="small"
            @click="onLearningClick(topic, unit)"
          >
            <span class="text-base">
              {{ percentCounter > 99 ? $t("virtual-class.review-lesson") : $t("virtual-class.start-learning") }}
            </span>
          </vs-button>

        </div>

        <div class="flex flex-col justify-end w-1/3">
          <p class="flex flex-1 text-grey justify-end items-center whitespace-pre">
            <span>
              {{ currentLearnTime }}/{{ totalVdoLength }}
            </span>
            <feather-icon class="cursor-pointer" icon="ClockIcon" svgClasses="stroke-current h-4 w-4 mr-2 p-0"/>
          </p>
          <span class="text-right text-xl">
            <feather-icon v-if="percentCounter > 99"
                          class="text-warning"
                          icon="StarIcon"
                          svgClasses="h-4 w-4 mr-2 p-0"/>
            {{ learnPercent }}%
          </span>
        </div>
      </div>
<!--    </div>-->
    <vs-divider v-if="index !== topicLength - 1"/>
  </div>
</template>

<script>
import {formatSecondToHHMMSS} from "@/utils/format";

export default {
  props: [
    'topic',
    'topicId',
    'unit',
    'studentUnitLearn',
    'index',
    'topicLength',
  ],
  data() {
    return {
      timerCounter: 0,
      percentCounter: 0,
      learnTime: 0,
      countUpdateInterval: 3
    }
  },
  computed: {
    currentLearnTime() {
      if (this.topic && this.topic.studentTopicLearn) {
        let learnTime = this.topic.studentTopicLearn.learnTime
        if (learnTime > this.topic.vdoLength) {
          learnTime = this.topic.vdoLength;
        }
        return formatSecondToHHMMSS(learnTime);
      } else {
        return 0;
      }
    },
    totalVdoLength() {
      return formatSecondToHHMMSS(this.topic.vdoLength);
    },
    learnPercent() {
      if (this.topic && this.topic.studentTopicLearn) {
        return this.topic.studentTopicLearn.learnPercent > this.topic.studentTopicLearn.learnPercent
          ? 100 : this.topic.studentTopicLearn.learnPercent;
      } else {
        return 0;
      }
    }
  },
  methods: {
    async onLearningClick(topic, unit) {
      this.$emit('handlerTopicClick', {topic, unit})
    },
  },
}
</script>

<style>

</style>
